module.exports = {
      id: "bangladesh-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#bangladesh-usage",
      toString: function () {
        return this.url;
      }
    }